import { useEffect } from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";

/**
 * Public URL alias for the ProspectMax ROI calculator.
 * Route: /tools/roi/:agencyId?rep=<userId>
 *
 * Redirects to the existing /roi-calculator?agency=<id>&rep=<id> page so agencies
 * can embed a clean, memorable /tools/roi/{id} URL on their websites (matches the
 * /tools/audit/{id} pattern).
 */
export default function PublicROIAliasPage() {
  const { agencyId } = useParams();
  const [params] = useSearchParams();
  const repId = params.get("rep") || "";
  const target = `/roi-calculator?agency=${encodeURIComponent(agencyId || "")}` +
    (repId ? `&rep=${encodeURIComponent(repId)}` : "");

  useEffect(() => {
    // Set a lightweight page title in case a slow redirect exposes this briefly
    document.title = "ROI Calculator";
  }, []);

  return <Navigate to={target} replace />;
}
